import { createAppSelector } from '../root'
import type { LocalConfigurationId, RecoverableConfiguration, TruckConfiguration } from '../slices/configurationSlice'

const sortNumber = (configuration: TruckConfiguration | RecoverableConfiguration, leadingConfiguration: LocalConfigurationId | undefined) =>
  configuration.id === leadingConfiguration ? -1 : configuration.sortOrder

export const selectOrderedTruckConfigurations = createAppSelector(
  [(state) => state.truckConfigurations.configurations, (state) => state.truckConfigurations.leadingConfiguration],
  // this is almost poor form to cast to EnhancedConfigurationId, but the lookup will be either undefined or be a configuration
  (configurations, leadingConfiguration): TruckConfiguration[] =>
    Object.values(configurations)
      .filter((x) => !!x)
      .toSorted((a, b) => sortNumber(a, leadingConfiguration) - sortNumber(b, leadingConfiguration)),
)

export const selectOrderedConfigurations = createAppSelector(
  [
    (state) => state.truckConfigurations.configurations,
    // (state) => state.truckConfigurations.pendingConfigurations,
    (state) => state.truckConfigurations.recoverableConfigurations,
    (state) => state.truckConfigurations.leadingConfiguration,
  ],
  (configs, recoverableConfigs, leadingConfiguration): (TruckConfiguration | RecoverableConfiguration)[] => {
    const configurations = Object.values(configs)
    const result: (TruckConfiguration | RecoverableConfiguration)[] = configurations.filter((x) => !!x)
    const withTabRecovery = import.meta.env.VITE_ENABLE_RECOVERY === 'true'
    if (withTabRecovery) {
      for (const recoverableConfig of recoverableConfigs) {
        if (result.some((x) => x.id === recoverableConfig.id)) {
          continue
        }
        result.push(recoverableConfig)
      }
    }
    return result.toSorted((a, b) => sortNumber(a, leadingConfiguration) - sortNumber(b, leadingConfiguration))
  },
)
